<style>
#sendSMS .values-list__element {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 10px;
  margin-top: 0px;
  border-bottom: 1px solid lightgrey;
  display: flex;
  justify-content: space-between;
  line-height: 32px;
}
#sendSMS *:not(.v-icon) {
  font-size: 12px;
}
#sendSMS #values-list > li:nth-child(2) > div:nth-child(3) > div {
  max-height: 32px;
}
#sendSMS .no-number-background {
  color: red;
}
</style>

<template>
  <Modal
    modalName="sendSMS"
    title="Powiadom odbiorców"
    :buttons="['clipboardNotice','sendMobile']"
    @saved="sendSMS"
    @closed="close"
    @copyToClipboard="copyToClipboard"
  >
    <div id="wrapper">
      <v-flex xs12>
        <div class="list--container">
          W celu wysłania powiadomienia SMS uzupełnij poniższy formularz, a następnie zaznacz odbiorców z poniższej listy.
          <v-layout
            row
            wrap
          >
            <v-flex xs5>
              <!-- <v-text-field label="Data wstrzymania dopływu wody" v-model="dateStart" type="date"></v-text-field> -->
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateFormattedStart"
                    label="Data wstrzymania dopływu wody"
                    @blur="dateStart = parseDate(dateFormattedStart)"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateStart"
                  @input="menu1 = false"
                  color="#2a579a"
                  locale="pl-pl"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <!-- <v-text-field
                label="Godzina wstrzymania dopływu wody"
                v-model="timeStart"
                type="time"
              ></v-text-field>-->
              <v-menu
                ref="menuTimeStart"
                :close-on-content-click="false"
                v-model="menuTimeStart"
                :nudge-right="40"
                :return-value.sync="timeStart"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="timeStart"
                  label="Godzina wstrzymania dopływu wody"
                ></v-text-field>
                <v-time-picker
                  v-if="menuTimeStart"
                  format="24hr"
                  v-model="timeStart"
                  color="#2a579a"
                  full-width
                  @change="$refs.menuTimeStart.save(timeStart)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
          >
            <v-flex xs5>
              <!-- <v-text-field
                label="Planowana data przywrócenia dopływu wody"
                v-model="dateEnd"
                type="date"
              ></v-text-field>-->
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateFormattedEnd"
                    label="Data przywrócenia dopływu wody"
                    @blur="dateEnd = parseDate(dateFormattedEnd)"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateEnd"
                  @input="menu2 = false"
                  color="#2a579a"
                  locale="pl-pl"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <!-- <v-text-field
                label="Planowana godzina przywrócenia dopływu wody"
                v-model="timeEnd"
                type="time"
              ></v-text-field>-->
              <v-menu
                ref="menuTimeEnd"
                :close-on-content-click="false"
                v-model="menuTimeEnd"
                :nudge-right="40"
                :return-value.sync="timeEnd"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="timeEnd"
                  label="Planowana godzina przywrócenia dopływu wody"
                ></v-text-field>
                <v-time-picker
                  v-if="menuTimeEnd"
                  format="24hr"
                  v-model="timeEnd"
                  color="#2a579a"
                  full-width
                  @change="$refs.menuTimeEnd.save(timeEnd)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
          >
            <v-flex xs5>
              <v-text-field
                label="Obszar"
                v-model="area"
              ></v-text-field>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-select
                label="Przyczyna"
                :items="causeList"
                v-model="cause"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
            v-if="cause == 'Inne'"
          >
            <v-flex xs12>
              <v-text-field
                label="Inna przyczyna"
                v-model="causeOther"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-textarea
            box
            name="sms-preview"
            label="Podgląd wiadomości SMS"
            v-model="messagePreview"
            readonly
            auto-grow
          ></v-textarea>

          <v-subheader>Lista klientów z dostępnymi numerami</v-subheader>
          <p v-if="Object.keys(watermetersObjFound).length === 0 && watermetersObjFound.constructor === Object">Brak klientów do wyświetlenia</p>
          <ul
            v-else
            id="values-list"
          >
            <template v-for="(val, key) in watermetersObjFound">
              <li
                :key="key"
                class="values-list__element list--el"
              >
                <v-flex>
                  <v-checkbox
                    v-model="selected"
                    :value="val.number"
                    :label="val.ulica + ' ' + val.nr_domu + ', ' + val.miejscowosc + ' (' + val.number + ')'"
                    v-if="val.nr_domu != ''"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="selected"
                    :value="val.number"
                    :label="val.ulica + ' ' + val.nr_lokalu + ', ' + val.miejscowosc + ' (' + val.number + ')'"
                    v-else
                  ></v-checkbox>
                </v-flex>
              </li>
            </template>
          </ul>
          <v-subheader>Lista klientów z niedostępnymi numerami</v-subheader>
          <p v-if="Object.keys(watermetersObjNotFound).length === 0 && watermetersObjNotFound.constructor === Object">Brak klientów do wyświetlenia</p>
          <ul
            v-else
            id="values-list"
          >
            <template v-for="(val, key) in watermetersObjNotFound">
              <li
                :key="key"
                class="values-list__element list--el"
              >
                <v-flex>
                  <p
                    v-if="val.nr_domu != ''"
                    v-text="val.ulica + ' ' + val.nr_domu + ', ' + val.miejscowosc"
                    class="no-number-background"
                  ></p>
                  <p
                    v-else
                    v-text="val.ulica + ' ' + val.nr_lokalu + ', ' + val.miejscowosc"
                    class="no-number-background"
                  ></p>
                </v-flex>
              </li>
            </template>
          </ul>
        </div>
      </v-flex>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    watermetersObjFound: {},
    watermetersObjNotFound: {},
    selected: [],
    dateStart: undefined,
    dateEnd: undefined,
    timeStart: undefined,
    timeEnd: undefined,
    area: undefined,
    cause: undefined,
    menuTimeStart: false,
    menuTimeEnd: false,
    causeOther: "",
    causeList: ["Awaria sieci", "Prace remontowe", "Inne"],
    ///////
    dateFormattedStart: undefined,
    dateFormattedEnd: undefined,
    menu1: false,
    menu2: false
  }),
  computed: {
    messagePreview() {
      return `
Szanowni Państwo! W dniu ${this.dateFormattedStart ||
        "..."} o godzinie ${this.timeStart ||
        "..."} nastąpi przerwa w dostawie wody. Powód: ${this.cause ||
        "..."}. Obszar: ${this.area ||
        "..."}. Przewidywany termin wznowienia dostaw wody: ${this
          .dateFormattedEnd || "..."}, godzina ${this.timeEnd ||
          "..."}. Przepraszamy za utrudnienia.`;
    }
  },
  watch: {
    dateStart(val) {
      this.dateFormattedStart = this.formatDate(this.dateStart)
    },
    dateEnd(val) {
      this.dateFormattedEnd = this.formatDate(this.dateEnd)
    }
  },
  methods: {
    formatDate(date) {
      if(!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    parseDate(date) {
      if(!date) return null

      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    validate() {
      if(
        !this.dateFormattedEnd ||
        !this.dateFormattedStart ||
        !this.area ||
        !this.timeStart ||
        !this.timeEnd ||
        !this.cause
      ) {
        this.$root.$emit("showSnackbar", "red", "Uzupełnij wszystkie pola");
        return false;
      }

      if(this.dateFormattedEnd < this.dateFormattedStart) {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Data wstrzymania nie może być późniejsza niż data przywrócenia wody"
        );
        return false;
      }

      if(
        this.dateFormattedEnd == this.dateFormattedStart &&
        this.timeEnd < this.timeStart
      ) {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Godzina wstrzymania nie może być późniejsza niż godzina przywrócenia wody"
        );
        return false;
      }

      return true;
    },
    loadWatermeters(data) {
      let payload = {
        watermeter_ids: data
      };

      this.$store.dispatch("getPhoneNumbers", payload).then(res => {
        if(res) {
          this.watermetersObjFound = res.data.found;
          this.watermetersObjNotFound = res.data.not_found;
          this.selected = Object.values(this.watermetersObjFound).map(
            el => el.number
          );
        } else {
          this.$root.$emit("showSnackbar", "red", `${res}`);
        }
      });
    },
    sendSMSDecision() {
      if (this.selected.length === 0) {
        this.$root.$emit("showSnackbar", "red", `Wybierz odbiorców wiadomości`);
        return;
      }

      if (!this.validate()) {
        return;
      }

      if (this.causeOther) {
        this.cause = this.causeOther;
      }

      let payload = {
        message: this.messagePreview.trim(),
        numbers: this.selected.map(el => el.toString())
      };
      this.$store.dispatch("sendSMS", payload).then(res => {
        if (res.status === 200) {
          this.$root.$emit("showSnackbar", "success", "Wysłano wiadomości");
          this.close();
        } else {
          this.$root.$emit("showSnackbar", "red", `${res}`);
        }
      });
    },
    sendSMS() {
      const self = this;
      self.$modal.show("dialog", {
        title: "Wysyłanie powiadomień",
        text: `Czy na pewno wysłać  wiadomość na wskazane numery?`,
        buttons: [
          {
            title: "NIE",
            handler: () => {
              self.$modal.hide("dialog");
            }
          },
          {
            title: "TAK",
            default: true,
            handler: () => {
              self.$modal.hide("dialog");
              self.sendSMSDecision();
            }
          }
        ]
      });
    },
    close() {
      this.watermetersObjFound = {};
      this.watermetersObjNotFound = {};
      this.selected = [];
      this.dateStart = undefined;
      this.dateEnd = undefined;
      this.timeStart = undefined;
      this.timeEnd = undefined;
      this.area = undefined;
      this.cause = undefined;
      this.menuTimeStart = false;
      this.menuTimeEnd = false;
      this.plannedStartDateFormatted = undefined;
      this.causeOther = "";
      this.dateFormattedStart = undefined;
      this.dateFormattedEnd = undefined;
      this.menu1 = false;
      this.menu2 = false;
    },
    copyToClipboard() {
      if(!this.validate()) {
        return;
      }
      let cause = this.cause.toLowerCase();
      if(this.causeOther) {
        let cause = this.causeOther;
      }
      let msg = `
<style>
.aquagis_notice {
  text-align: center;
}
</style>

<div class="aquagis_notice">
  <h2>Szanowni Państwo!</h4>
  <p>W dniu ${this.plannedStartDateFormatted} o godzinie ${
        this.timeStart
        } nastąpi przerwa w dostawie wody.</p>
  <p>Powód: ${cause}</p>
  <p>Obszar: ${this.area}</p>
  <p>Przewidywany termin wznowienia dostaw wody: ${
        this.plannedReturnDateFormatted
        }, godzina ${this.timeEnd}.</p>
  <h3>Przepraszamy za utrudnienia.</h3>
</div>
`;

      const el = document.createElement("textarea");
      el.value = msg;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.$root.$emit("showSnackbar", "#2a579a", "Skopiowano do schowka");
    }
  },
  mounted() {
    this.$root.$on("sendWatermetersId", this.loadWatermeters);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/analysis/modals/SendSMS.vue